import React, {useEffect} from "react";
import Axios from "axios";
import {mainUrl} from "../../api/axios";
import {Button, CardBody, Col, Input, Row} from "reactstrap";
import {Form, FormGroup} from "react-bootstrap";

function SearchItem(props) {

    const [provinceList, setProvinceList] = React.useState([]);
    const [locationList, setLocationList] = React.useState([]);
    const [positionList, setPositionList] = React.useState([]);
    // const [reportTypeId, setReportTypeId] = React.useState(reportType);

    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Header': '*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    }

    useEffect(() => {
        loadData();
    }, []);

    const loadData= async()=>{
        await Promise.all([getPositions(),getLocations(),getProvinces()])
            .then(function (results) {
                setPositionList(results[0].data);
                setLocationList(results[1].data);
                setProvinceList(results[2].data);
                props.setIsLoading(1);
            }).catch(function (thrown) {
                if (Axios.isCancel(thrown)) {
                    console.log('Request canceled', thrown.message);
                } else {
                    // handle error
                }
            });;
    }
    function getPositions() {
        return Axios.get(mainUrl + "getPosition",{headers});
    }
    function getLocations() {
        return Axios.get(mainUrl + "getLocation",{headers});
    }
    function getProvinces() {
        return Axios.get(mainUrl + "getProvince",{headers});
    }

    var curr = new Date();
    curr.setDate(curr.getDate() + 3);
    var date = curr.toISOString().substr(0, 10);


    const setReport = async (e) => {
        e.preventDefault();
        props.setList([]);
        props.setReportType(e.target.value);
    }
    const generateReport = async (e) => {
        e.preventDefault();
        const f = e.target;

        if (props.reportType == 1) {

            props.setIsLoading(1);
            const hData= await Axios.post(mainUrl + "employeeById", {
                employee_id: f.employee_id.value
            }, {headers});

            const listsD = hData.data[0];
            if (listsD!= null) {
                props.setHeaderData(listsD);
                const {data} = await Axios.post(mainUrl + "generateReport", {
                    employee_id: f.employee_id.value,
                    start_date: f.start_date.value,
                    end_date: f.end_date.value,
                }, {headers});
                const lists = data;
                props.setPeriodDate({
                    "startDate": document.getElementById('start_date').value,
                    "endDate": document.getElementById('end_date').value,
                    "workDays": lists.length
                })
                props.setList(lists);
            } else {
                props.setList([]);
                props.setHeaderData({});
            }
            props.setIsLoading(1);
        } else if (props.reportType == 2) {
            const {data} = await Axios.post(mainUrl + "generateReport", {
                province_id: f.province_id.value,
                location_id: f.location_id.value,
                position_id: f.position_id.value,
                start_date: f.start_date.value,
                end_date: f.end_date.value,
            }, {headers});

            const lists = data;
            props.setList(lists);
        }
    }
    return (
        <>
            <CardBody className="mr-4 ml-4">
                <Form onSubmit={(e) => generateReport(e)}>
                    <Row>
                        <Col className="px-1" md="12">
                            <FormGroup>
                                <label>Report Type <span className="text text-danger">*</span></label>
                                <select name="report_type_id" id="report_type_id" title="Report type" defaultValue={props.reportType}
                                        className="form-control" onChange={(e) => setReport(e)}>
                                    <option value="0"></option>
                                    <option value="1">Review the Employee Salary Analysis</option>
                                    <option value="2">Monthly Salary Report</option>

                                </select>
                            </FormGroup>
                        </Col>
                        {props.reportType == 1 && (
                            <Col className="px-1" md="4">
                                <FormGroup>
                                    <label>Employee Id <span className="text text-danger">*</span></label>
                                    <input type="text" className="form-control" placeholder="Employee id"
                                           name="employee_id" id="employee_id"/>
                                </FormGroup>
                            </Col>)
                        }
                        {props.reportType == 2 && (
                            <>
                                <Col className="px-1" md="4">
                                    <FormGroup>
                                        <label>Province <span className="text text-danger">*</span></label>
                                        <select name="province_id" id="province_id" title="Province"
                                                className="form-control">
                                            <option value=""></option>
                                            {provinceList.map((e, index) => (
                                                <option key={index}
                                                        value={e.id}>{e.name}</option>
                                            ))}
                                        </select>
                                    </FormGroup>
                                </Col>

                                <Col className="px-1" md="4">
                                    <FormGroup>
                                        <label>Location <span className="text text-danger">*</span></label>
                                        <select name="location_id" id="location_id" title="Location"
                                                id="location_id"
                                                className="form-control">
                                            <option value=""></option>
                                            {locationList.map((e, index) => (
                                                <option key={index}
                                                        value={e.id}>{e.location_name}</option>
                                            ))}
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col className="px-1" md="4">
                                    <FormGroup>
                                        <label>Position <span className="text text-danger">*</span></label>
                                        <select name="position_id" id="position_id" title="Position"
                                                className="form-control">
                                            <option value=""></option>
                                            {positionList.map((e, index) => (
                                                <option key={index}
                                                        value={e.id}>{e.name}</option>
                                            ))}
                                        </select>
                                    </FormGroup>
                                </Col>
                            </>
                        )}
                        <Col className="px-1" md="4">
                            <FormGroup>
                                <label>Start Date <span className="text text-danger">*</span></label>
                                <Input type="date" title="Start Date" placeholder="Start Date" defaultValue={date}
                                       id="start_date"
                                       name="start_date"/>
                            </FormGroup>
                        </Col>
                        <Col className="px-1" md="4">
                            <FormGroup>
                                <label>End Date <span className="text text-danger">*</span></label>
                                <Input type="date" title="End Date" placeholder="End Date" id="end_date"
                                       defaultValue={date}
                                       name="end_date"/>
                            </FormGroup>
                        </Col>

                    </Row>

                    <Row>
                        <div className="ml-end">
                            <Button title="Generate Report" className="btn btn-danger btn-round" type="submit">
                                <span className="nc-icon nc-zoom-split"/>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                Generate
                                &nbsp;
                            </Button>
                        </div>
                    </Row>
                </Form>
            </CardBody>
        </>
    );
}



export default SearchItem;